import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomPreciosProveedoresDeCompraProductos
 * @author: Anderson Acevedo Briñez
 * @updateBy 
 * @version: jdesk_1.01.0001
 **/
class CustomPreciosProveedoresDeCompraProductos extends FormJaivana.form {
  constructor(props) {
    super(props);
    this.initForm                          = this.initForm.bind(this);
    this.successguardarProductoProveedor = this.successguardarProductoProveedor.bind(this);
    this.guardarProductoProveedor = this.guardarProductoProveedor.bind(this);
    this.buscaProductoProveedores =this.buscaProductoProveedores.bind(this);
    this.succesConsulta  = this.succesConsulta.bind(this);
	  this.mostrarCampos	=	this.mostrarCampos.bind(this);
    this.ocultarCampos =  this.ocultarCampos.bind(this);
    this.ocultarCamposCancelar  = this.ocultarCamposCancelar.bind(this);
    this.setBotones  = this.setBotones.bind(this);
    this.accionProcesar  = this.accionProcesar.bind(this);
    this.crearBotonTabla  = this.crearBotonTabla.bind(this);
    this.validarEliminar  = this.validarEliminar.bind(this);
    this.successEliminar  = this.successEliminar.bind(this);
    this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
    this.formatNumberSaldo = this.formatNumberSaldo.bind(this);

    this.gridOptionsComponentes = Object.assign({}, this.gridOptions);

    this.onSelectionChangedPrincipal = this.onSelectionChangedPrincipal.bind(this);
    this.gridOptionsComponentes['onSelectionChanged'] = this.onSelectionChangedPrincipal;

    this.validarUnique	=	this.validarUnique.bind(this);
    this.succesConsultaUnique	=	this.succesConsultaUnique.bind(this);
    this.contiene_registros=false;
    this.numero_registros=0;
  }

  initForm() {
    console.log("Formulario CustomPreciosProveedoresDeCompraProductos,  @version: jdesk_1.01.0009.3, @author: Anderson Acevedo Briñez, @Modificado por : Anderson Acevedo, Fecha de Modificación: 04/06/2025 ");
    this.getField('consultar').setClick(this.buscaProductoProveedores);
	  this.getField('terceros_id').setOnChange((props)=>{
        if(this.getField('terceros_id').getValue()!==''){
          this.getField('consultar').setDisabled(false);
          this.ocultarCampos();
        }else{
          this.getField('consultar').setDisabled(true);
          this.ocultarCampos();
        }
    });
    
    this.getField('articulo_id').setOnChange((props)=>{
        this.getField('nombre_articulo').setError(false,'');
    });



    this.getField('bt_guardar').setClick(this.validarUnique);
    this.getField('bt_cancelar').setClick(this.ocultarCamposCancelar);
    this.getField('agregar').setClick(()=>{
      this.getField('agregar').setVisible(false);
      this.mostrarCampos()
      ;});
    this.getField('consultar').setDisabled(true);
    this.ocultarCampos();
  }


  onSelectionChangedPrincipal(){

  }

  currencyFormatterGeneral(number,numero_decimales) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > numero_decimales) {
                number = number.toFixed(numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


  mostrarCampos(){
      this.getField('bt_guardar').setVisible(true);
      this.getField('bt_cancelar').setVisible(true);

      this.getField('codigo_articulo').setVisible(true);
      this.getField('nombre_articulo').setVisible(true);
      this.getField('producto_proveedor').setVisible(true);
      this.getField('nombre_producto_proveedor').setVisible(true);
      this.getField('operador').setVisible(true);
      this.getField('factor').setVisible(true);
      this.getField('precio').setVisible(true);
  }
  
  ocultarCampos(){
      this.getField('rejilla').toggle(false);
      this.getField('bt_guardar').setVisible(false);
      this.getField('agregar').setVisible(false);
      this.getField('bt_cancelar').setVisible(false);

      this.getField('codigo_articulo').setVisible(false);
      this.getField('nombre_articulo').setVisible(false);
      this.getField('producto_proveedor').setVisible(false);
      this.getField('nombre_producto_proveedor').setVisible(false);
      this.getField('operador').setVisible(false);
      this.getField('factor').setVisible(false);
      this.getField('precio').setVisible(false);

      this.getField('codigo_articulo').setValue('');
      this.getField('nombre_articulo').setValue('');
      this.getField('articulo_id').setValue('');
      this.getField('producto_proveedor').setValue('');
      this.getField('nombre_producto_proveedor').setValue('');
      this.getField('operador').setValue(' ');
      this.getField('factor').setValue('');
      this.getField('precio').setValue('');


      this.getField('codigo_articulo').setError(false,'');
      this.getField('nombre_articulo').setError(false,'');
      this.getField('articulo_id').setError(false,'');
      this.getField('producto_proveedor').setError(false,'');
      this.getField('nombre_producto_proveedor').setError(false,'');
      this.getField('operador').setError(false,'');
      this.getField('factor').setError(false,'');
      this.getField('precio').setError(false,'');
  }

  ocultarCamposCancelar(){
    if(this.contiene_registros===true){
      //this.getField('rejilla').input.focus();
      this.getField('agregar').setVisible(true);
    }else{
      this.getField('agregar').setVisible(false);
      this.getField('consultar').setDisabled(false);
      this.getField('nit').input.focus();
    }
    this.getField('bt_guardar').setVisible(false);
    this.getField('bt_cancelar').setVisible(false);

    this.getField('codigo_articulo').setVisible(false);
    this.getField('nombre_articulo').setVisible(false);
    this.getField('producto_proveedor').setVisible(false);
    this.getField('nombre_producto_proveedor').setVisible(false);
    this.getField('operador').setVisible(false);
    this.getField('factor').setVisible(false);
    this.getField('precio').setVisible(false);

    this.getField('codigo_articulo').setValue('');
    this.getField('nombre_articulo').setValue('');
    this.getField('articulo_id').setValue('');
    this.getField('producto_proveedor').setValue('');
    this.getField('nombre_producto_proveedor').setValue('');
    this.getField('operador').setValue(' ');
    this.getField('factor').setValue('');
    this.getField('precio').setValue('');


    this.getField('codigo_articulo').setError(false,'');
    this.getField('nombre_articulo').setError(false,'');
    this.getField('articulo_id').setError(false,'');
    this.getField('producto_proveedor').setError(false,'');
    this.getField('nombre_producto_proveedor').setError(false,'');
    this.getField('operador').setError(false,'');
    this.getField('factor').setError(false,'');
    this.getField('precio').setError(false,'');

    
  }

  buscaProductoProveedores(){
    if(this.getField('nit').valid()
        && this.getField('sede').valid()
        && this.getField('nombre').valid()){
        this.ocultarCampos();
        let datos={ 
            datos: {
              terceros_id:this.getField('terceros_id').getValue(),  
            }};
        this.generalFormatPmv = { tipo_servicio: 'maes-preciosproveedores', operacion: '1_1', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.succesConsulta,
                error: this.error_,
                general: this.generalFormatPmv
        });
    }
  }

  succesConsulta(data){
      if (data.estado_p === 200 )
      {
          this.getField('agregar').setVisible(true);
          this.numero_registros=data.data.length;
          this.contiene_registros=true;
          this.getField('consultar').setDisabled(true);
          this.getField('rejilla').toggle(true);
          let configCell = new Map();

          configCell.set('accion', { cellRenderer: this.setBotones, headerName: 'Acción',width:360, sortable: false, filter: false });
        
          configCell.set('factor', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.factor,2) }, cellStyle: { textAlign: "right" } });
          configCell.set('precio', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.precio,4) }, cellStyle: { textAlign: "right" } });

          this.gridOptionsComponentes['rowData'] = data.data;
          this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);
      }
      else 
      {
		  if (data.estado_p === 404 ){
        this.numero_registros=0;
        this.contiene_registros=false;
			  this.getField('rejilla').toggle(false);
			  this.getField('consultar').setDisabled(true);
			  this.mostrarCampos();
		  }else{
        this.numero_registros=0;
			  this.getField('rejilla').toggle(false);
			  let respuesta=Object.values(data.data.errores);
			  let keys=Object.keys(data.data.errores);
			  this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error'); 
		  }
      };
  }

  //crear botones

  setBotones(props) {
        let fragment = document.createDocumentFragment();
        let buttonEliminar = this.crearBotonTabla(props.data, 'Eliminar');
        //let btnAgregar = this.crearBotonTabla(props.data, 'Agregar');
        buttonEliminar.setAttribute("class","buttonStyle2");
        //btnAgregar.setAttribute("class","buttonStyle2");

        fragment.appendChild(buttonEliminar);
        //fragment.appendChild(btnAgregar);
        return this.createElementJaivana(fragment);
    }


    crearBotonTabla(data, boton) {
        let button = document.createElement('input');
        switch (boton) {
            case 'Eliminar':
                button.setAttribute("id", `buttonEliminar_${data.id}`);
                break;

            case 'Ver más':
                button.setAttribute("id", `buttonVerMas_${data.id}`);
                break;

            case 'Devolver':
                button.setAttribute("id", `buttonDevolver_${data.id}`);
                break;

            default:
                break;
        }
        button.onclick = () => { this.accionProcesar(data, boton) };
        button.setAttribute("value", boton);
        button.setAttribute("type", "button");
        return button;
    }

    /**
      * @param {La información que contiene el registro seleccionado} data 
      * @param {El botón al cual se le dió click ("Eliminar", "Ver más")} boton 
      */
    accionProcesar(data, boton) {
        if (boton === 'Eliminar') {
            this.getField('confirmModalCustom').setTitleAndContent('Eliminar', '¿Desea realizar esta operación?');
            this.getField('confirmModalCustom').setClickDialog(() => { this.validarEliminar(data.id) });
            this.getField("confirmModalCustom").setVisibleCancel(false);
            this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
            this.getField('confirmModalCustom').toggle(true);
        } else if (boton === 'Agregar') {
            this.mostrarCampos();
        } else {
            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `Ninguna acción pertenece a la acción de este botón`);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }
    }

    validarEliminar(id) {
        this.getField('confirmModalCustom').toggle(false);
        if (id !== '') {
            let datos = {
                datos: {
                    articulos_precios_proveedores_id: id+''
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'maes-preciosproveedores', operacion: '7', operacion_tipo: 'eliminar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'DELETE',
                    body: datos,
                    success: this.successEliminar,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successEliminar(data) {
        if (data.estado_p === 200) {
            this.buscaProductoProveedores();
        }else {
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        };
    }
  
  validarUnique(){

    if(this.getField('codigo_articulo').valid()&&
      this.getField('nombre_articulo').valid()&&
      this.getField('articulo_id').valid() &&
	    this.getField('producto_proveedor').valid() &&
      this.getField('nombre_producto_proveedor').valid() &&
      this.getField('operador').valid() &&
      this.getField('factor').valid() &&
      this.getField('precio').valid()
      ){
        let datos={ 
            datos: {
              articulo_id:this.getField('articulo_id').getValue(),  
              producto_proveedor:this.getField('producto_proveedor').getValue(),
              terceros_id:this.getField('terceros_id').getValue()
            }};
        this.generalFormatPmv = { tipo_servicio: 'maes-preciosproveedores', operacion: '20', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.succesConsultaUnique,
                error: this.error_,
                general: this.generalFormatPmv
        });
    }
  }

  succesConsultaUnique(data){
      if (data.estado_p === 200 )
      {
        let mensaje='No se debe repetir terceros_id+articulo_id+producto_proveedor';
        this.alertGeneral.toggle(true, mensaje, 'error');
      }
      else 
      {
        if(data.estado_p===404){
          this.guardarProductoProveedor();
        }else{
          let respuesta=Object.values(data.data.errores);
          let keys=Object.keys(data.data.errores);
          this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
        }
      };
  }

  guardarProductoProveedor(){
    
      this.getField('codigo_articulo').valid()&&
      this.getField('nombre_articulo').valid()&&
      this.getField('articulo_id').valid() &&
	    this.getField('producto_proveedor').valid() &&
      this.getField('nombre_producto_proveedor').valid() &&
      this.getField('operador').valid() &&
      this.getField('factor').valid() &&
      this.getField('precio').valid()

      let datos = { datos: {
        terceros_id:this.getField('terceros_id').getValue(),
        articulo_id:this.getField('articulo_id').getValue(),
        producto_proveedor:this.getField('producto_proveedor').getValue(),
        nombre_producto_proveedor:this.getField('nombre_producto_proveedor').getValue(),
        operador:this.getField('operador').getValue(),
        factor:this.getField('factor').getValue(),
        precio:this.getField('precio').getValue(),
      }};
      
      this.generalFormatPmv = { tipo_servicio: 'maes-preciosproveedores', operacion: '5', operacion_tipo: 'crear' };
      this.datos_anteriores=this.generalFormatPmv;
      this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successguardarProductoProveedor,
                error: this.error_,
                general: this.generalFormatPmv
        });
  }

  successguardarProductoProveedor(data) 
  {

    if (data.estado_p === 200)
    {
        this.ocultarCampos();
        this.buscaProductoProveedores();
    }
    else 
    {
      let respuesta=Object.values(data.data.errores);
      let keys=Object.keys(data.data.errores);
      this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
    }
  }

}
FormJaivana.addController("maes-preciosproveedores", CustomPreciosProveedoresDeCompraProductos);
export default CustomPreciosProveedoresDeCompraProductos;